import React        from 'react';
import styled       from 'styled-components';
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
}                   from '@material-ui/core';
import { INavItem } from '@utils/navigation';

interface IBreadcrumbsProps {
  push         : (path: string) => void;
  breadcrumbs? : INavItem[];
  handleGoHome : () => void;
}

const BreadcrumbsWrapper = styled(MuiBreadcrumbs)`
  margin: 0 0 -5px 24px !important;

  @media (min-width: 960px) {
    margin: 0 0 -4px 24px !important;
  }

  li:last-child {
    cursor         : default;
    pointer-events : none;
  }
`;

const BreadcrumbLink = styled(Link)`
  && {
    font-size       : 16px;
    font-weight     : 500;
    cursor          : pointer;
    text-decoration : none !important;
    color           : ${({ theme: { textColor } }): string => textColor.darkGray};

    @media (min-width: 960px) {
      font-size: 20px;
    }
  }
`;

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({
  push,
  breadcrumbs,
  handleGoHome,
}: IBreadcrumbsProps): JSX.Element => (
  <BreadcrumbsWrapper separator="›" aria-label="breadcrumb">
    <BreadcrumbLink
      color   = "inherit"
      onClick = {handleGoHome}
    >
      Intranet
    </BreadcrumbLink>
    {(breadcrumbs ?? []).map((x: INavItem): JSX.Element => {
      const { path, crumb } = x;

      return (
        <BreadcrumbLink
          key     = {crumb}
          color   = "inherit"
          onClick = {(): any => path && push(path)}
        >
          {x.title}
        </BreadcrumbLink>
      );
    })}
  </BreadcrumbsWrapper>
);
